'use client';

import { HomePage } from 'structure/home/containers/homepage';
import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';
import { HeaderHomePage } from 'structure/Layouts/SFILayouts/BaseLayout/components/HeaderHomePage';

export default function IndexPage() {
  return (
    <BaseLayout header={<HeaderHomePage />}>
      <HomePage />
    </BaseLayout>
  );
}
